<template>
  <div class="page-bg page">
    <SubHeader :title="headerTitle"></SubHeader>

    <div class="main">
      <div class="page-content">
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
          >
            <div class="goods-list">
              <div class="goods-list-wrap">
                <div
                  class="item"
                  :class="goodsWrap === 1 ? '' : 'goods-wrap-2'"
                  v-for="(item, index) in favs"
                  :key="index"
                  @click="$router.push('/goods/details?id=' + item.slide_id)"
                >
                  <div class="item-goods-box">
                    <div class="item-img">
                      <!-- <div class="preview-img" :style="{ backgroundImage: 'url('+item.image_url+')' }"></div> -->
                      <div
                        class="preview-img"
                        v-lazy:background-image="item.avatarimg"
                      ></div>

                      <div class="item-state" :class="'state-' + item.status">
                        <span>{{
                          Number(item.status) === 1
                            ? "热卖中"
                            : Number(item.status) === 2
                            ? "已售罄"
                            : "敬请期待"
                        }}</span>
                      </div>
                      <div class="item-collection">
                        <div class="icon"></div>
                        <div class="text">{{ item.collection_num }}</div>
                      </div>
                      <div class="item-label" v-if="Number(item.parent) === 0">
                        版
                      </div>
                      <div class="item-limit">
                        <div class="text">
                          限购:
                          <span>{{ item.num + " / " + item.all_num }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="item-info">
                      <div class="info-fl">
                        <div class="title">{{ item.title }}</div>
                        <div class="author">{{ item.author }}</div>
                      </div>
                      <div class="info-fr">
                        <div class="price">
                          ￥{{ item.price | formatMoney }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="com-empty" v-show="favs.length < 1" >
              <div class="empty">
                <div>
                  <p>暂无记录</p>
                  <img :src="require('@/assets/images/common/ic-empty.png')" alt="" />
                
                  <div class="set-btn2" style="margin-top:0.5rem">
                    <van-button @click="$router.replace('/goods')" >前往收藏</van-button>
                  </div>

                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
  </div>
</template>


<script>
import SubHeader from "../../../components/sub_header";

import Vue from "vue";
import { mapActions, mapState } from "vuex";
// import IScroll from '../../../assets/js/libs/iscroll';
import { List, PullRefresh, Lazyload, Toast,Button } from "vant";

Vue.use(Toast);
Vue.use(List);
Vue.use(PullRefresh);
Vue.use(Button);
Vue.use(Lazyload, {
  lazyComponent: true,
});

export default {
  name: "collection",
  data() {
    return {
      goodsWrap: 2,
      loading: false,
      finished: false,
      refreshing: false,
    };
  },
  components: {
    SubHeader,
  },

  created() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
  methods: {
    ...mapActions({
      getCollection: "user/getCollection",
    }),

    goodsWrapBtn() {
      let index = this.goodsWrap;
      if (index === 1) {
        this.goodsWrap = 2;
      } else {
        this.goodsWrap = 1;
      }
    },

    onLoad() {
      this.getCollection({
        success: (res) => {
          if (this.refreshing) {
            // this.list = [];
            this.refreshing = false;
          }
          this.loading = false;
          this.finished = true;
        },
      });
    },

    // 下拉刷新
    onRefresh() {
      // 清空列表数据
      this.finished = false;
      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
  },
  computed: {
    ...mapState({
      favs: (state) => state.user.favs,
    }),
  },

  mounted() {},

  activated() {
    document.title = this.$route.meta.title;
    this.headerTitle = this.$route.meta.title;
  },
};
</script>

<style lang="scss" scoped>
@import "../../../assets/css/goods/goodList.scss";

.page {
  width: 100%;
  background-size: cover;
  box-sizing: border-box;
  height: 100vh;
}

.main {
  width: 100%;
  box-sizing: border-box;
  height: calc(100vh - 1.45rem);
  position: relative;
}
.page-content {
  position: relative;
  overflow-y: auto;
  height: 100%;
}
</style>

